export default "__VITE_ASSET__BDKu733x__"